<template>
  <b-modal
    id="package-reservation-choose-player-modal"
    :title="trans('choose_a_player')"
    :ok-title="trans('save')"
    :ok-disabled="busy || !canSave"
    :cancel-title="trans('cancel')"
    size="lg"
    no-enforce-focus
    @shown="onShown"
    @hidden="onHidden"
    @ok="onSave"
  >
    <form-person-question
      v-if="!!question"
      :organization="organization"
      :question="question"
      v-model="json"
      :context-package="pkg"
      :disabled="busy"
    ></form-person-question>

    <p v-if="busy" class="lead text-center my-4">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  import FormPersonQuestion from './../form-questions/FormPersonQuestion'

  export default {
    props: {
      organization: Object,
      pkg: Object,
      invoice: Object,
      invoiceItem: Object, // addon
    },
    components: {
      FormPersonQuestion,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        question: null,
        answer: null,
        json: null,
        try_force: false,
      }
    },
    computed: {
      serialized() {
        return {
          value: this.json || null,
        }
      },
      canSave() {
        return !!this.json
      },
    },
    methods: {
      onShown() {
        this.loadQuestionAndAnswer()
        this.try_force = false
      },
      onHidden() {
        this.busy = false
        this.error = null
        this.question = null
        this.answer = null
      },
      loadQuestionAndAnswer() {
        this.busy = true
        this.error = null
        let url = `/org/${this.organization.id}/cart/player_on_addon_invoice_item/${this.invoiceItem.id}`
        axios.get(url)
        .then(response => {
          this.busy = false
          this.question = response.data.question
          this.answer = response.data.answer
          this.json = !!this.answer ? this.answer.json : null
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onSave(e) {
        e.preventDefault()

        this.busy = true
        this.error = null
        let url = `/org/${this.organization.id}/cart/player_on_addon_invoice_item/${this.invoiceItem.id}`
        if (this.try_force) url += '?try_force=true'
        axios.patch(url, this.serialized)
        .then(response => {
          this.busy = false
          this.$emit('invoice', response.data)
          this.$bvModal.hide('package-reservation-choose-player-modal')
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          if (error.response.status == 422) {
            this.try_force = true
          }
        })
      },
    },
    mounted() {
      window.choosePlayerModal = this
    },
  }
</script>